import React, { FC } from 'react'
import { Radio, Input, Space } from 'antd'
import { RadioGroupProps as AntRadioGroupProps } from 'antd/lib/radio'
import { CheckboxOptionType } from 'antd/lib/checkbox'
import styles from './_.module.css'

export type RadioGroupProps = AntRadioGroupProps

interface Props extends RadioGroupProps {
  options: CheckboxOptionType[] | undefined
  customInput: string
  setCustomInput: (value: string) => void
}
export const CustomRadio: FC<Props> = ({
  className,
  name,
  value,
  defaultValue,
  disabled,
  onChange,
  optionType,
  buttonStyle,
  options,
  customInput,
  setCustomInput
}) => {
  const controlledProps = {
    ...(value !== undefined && { value }),
    ...(onChange !== undefined && { onChange })
  }
  return (
    <div>
      <Radio.Group
        name={name}
        className={className}
        defaultValue={defaultValue}
        disabled={disabled}
        optionType={optionType}
        buttonStyle={buttonStyle}
        {...controlledProps}
      >
        <Space direction="vertical">
          {options?.map((option, index) => (
            <Radio key={index} value={option.value}>
              {option.label}
            </Radio>
          ))}
          <Radio value="other">
            I want to specify
            {value === 'other' ? (
              <Input
                value={customInput}
                size="small"
                className={styles.customInputField}
                type="number"
                onChange={e => setCustomInput(e.target.value)}
              />
            ) : null}
          </Radio>
        </Space>
      </Radio.Group>
    </div>
  )
}
